import React from 'react';
import VidaHeader from '../vida-header';
import VidaSection from '../vida-section';
import SubscriptionGrid from '../../subscription-grid';
import VidaSubscriptionAccess from '../vida-subscription-access';

const VidaPurchase: React.FC = () => (
  <div className="vida-content">
    <VidaHeader>VIDA for Independent Repair</VidaHeader>
    <VidaSection
      title="VIDA Subscriptions and Pricing"
      id="vida-subscriptions-and-pricing"
    >
      <p>
        Before placing your order, be sure to review the information regarding
        what is included with each subscription and the documentation for
        activating and using the VIDA system.
      </p>
      <p>
        When creating your VTI account, you must enter a valid name under the
        Company section (do not use “N/A”, “none”, “Consumer”, “Other”, etc.).
        All information fields should have correct information.
      </p>
      <p>
        Subscriptions are available in 3-day, 30-day, and 365-day durations. Any
        subscription may be extended or renewed for up to one year’s total
        duration.
        <br />
        Please be aware that bulletin subscriptions are a mandatory component of
        a VIDA subscription. Although they are priced separately, the cost is
        included as an additional charge within the subscription and cannot be
        removed.
        <br />
        All subscriptions include ongoing support for troubleshooting
        subscription and application performance.
      </p>
      <p>
        <strong>Important:</strong> For{' '}
        <strong>SPA and newer Volvo platforms,</strong>{' '}
        diagnostics/redouts/Wiring Diagrams etc. require a VIDA subscription
        that <strong>includes software download capability.</strong>
        Subscriptions without software download access{' '}
        <strong>will not unlock the VGM,</strong>
        and diagnostics/readouts/wiring diagrams{' '}
        <strong>cannot be performed</strong> on these vehicles.
      </p>
      <SubscriptionGrid />
    </VidaSection>
    <div className="divider" />
    <VidaSection
      title="Purchase VIDA and Bulletin Subscriptions"
      id="purchase-vida-subscription"
    >
      <VidaSubscriptionAccess />
    </VidaSection>
    {/* language=CSS */}
    <style jsx>{`
      .vida-content {
        padding: 2rem 3rem;
        font-family: 'Volvo Novum', sans-serif;
        font-size: 14px;
        min-height: 30rem;
      }

      strong {
        font-weight: 500;
      }

      table {
        padding: 1rem 3rem;
      }

      table tr td {
        padding: 1rem;
      }

      tr:nth-child(even) {
        background-color: #eee;
      }

      blockquote {
        border-left: 5px solid #ddd;
        padding-left: 1rem;
      }

      .divider {
        margin: 3rem auto;
        height: 1px;
        background-color: #eee;
        width: 80%;
      }
    `}</style>
  </div>
);

export default VidaPurchase;
